import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';

function AddOrganizerUserModal(props) {
  const { addOrganizerUser, confirmBtnText, ...rest } = props;
  const [form, setForm] = useState();
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setForm({
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      year: null,
      month: null,
      day: null,
      street: '',
      zipCode: '',
      city: '',
      nationality: '',
    });
    setErrors({});
  }, [props.show]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });

    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const handleSubmit = () => {
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      let updatedForm = {
        ...form,
        birthDate: {
          year: form.year ? parseInt(form.year) : 0,
          month: form.month ? parseInt(form.month) : 0,
          day: form.day ? parseInt(form.day) : 0,
        },
      };
      delete updatedForm.year;
      delete updatedForm.month;
      delete updatedForm.day;

      addOrganizerUser(updatedForm);
    }
  };

  const findFormErrors = () => {
    const {
      email,
      firstName,
      lastName,
      phoneNumber,
      year,
      month,
      day,
      zipCode,
      city,
      password,
    } = form;
    const newErrors = {};
    const validEmailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const validNumberRegex = /^[0-9]+$/;
    const validTextRegex = /^[A-Öa-ö\- ]*$/;

    // email errors
    if (!email || email === '') {
      newErrors.email = 'Du måste ange en e-post.';
    } else if (validEmailRegex.test(email) === false) {
      newErrors.email = 'Felaktigt format på e-post.';
    }
    // password errors
    if (!password || password === '') {
      newErrors.password = 'Du måste ange ett lösenord.';
    } else if (/[0-9]/.test(password) === false) {
      newErrors.password = 'Lösenordet måste innehålla minst en siffra.';
    } else if (/[a-z]/.test(password) === false) {
      newErrors.password = 'Lösenordet måste innehålla minst en liten bokstav.';
    } else if (/[A-Z]/.test(password) === false) {
      newErrors.password = 'Lösenordet måste innehålla minst en stor bokstav.';
    } else if (
      /[""!@$%^&*(){}\[\]:;<>,.?/+_=|'~\\-]/.test(password) === false
    ) {
      newErrors.password =
        'Lösenordet måste innehålla minst ett specialtecken.';
    }
    // firstName errors
    if (!firstName || firstName === '') {
      newErrors.firstName = 'Du måste ange ett förnamn.';
    } else if (validTextRegex.test(firstName) === false) {
      newErrors.firstName = 'Endast bokstäver tillåtet';
    }
    // lastName errors
    if (!lastName || lastName === '') {
      newErrors.lastName = 'Du måste ange ett efternamn.';
    } else if (validTextRegex.test(lastName) === false) {
      newErrors.lastName = 'Endast bokstäver tillåtet';
    }
    // phoneNumber errors
    if (phoneNumber !== '') {
      if (validNumberRegex.test(phoneNumber) === false) {
        newErrors.phoneNumber = 'Endast siffror tillåtet.';
      }
    }
    // year errors
    if (year !== null) {
      if (validNumberRegex.test(year) === false) {
        newErrors.year = 'Endast siffror tillåtet.';
      } else if (year.toString().length !== 4) {
        newErrors.year = 'År måste vara 4 siffror.';
      }
    }
    // month errors
    if (month !== null) {
      if (validNumberRegex.test(month) === false) {
        newErrors.year = 'Endast siffror tillåtet.';
      } else if (month.toString().length < 1) {
        newErrors.month = 'Månad måste vara mellan 1 och 2 siffror.';
      } else if (month.toString().length > 2) {
        newErrors.month = 'Månad måste vara mellan 1 och 2 siffror.';
      }
    }
    // day errors
    if (day !== null) {
      if (validNumberRegex.test(day) === false) {
        newErrors.year = 'Endast siffror tillåtet.';
      } else if (day.toString().length < 1) {
        newErrors.day = 'Dag måste vara mellan 1 och 2 siffror.';
      } else if (day.toString().length > 2) {
        newErrors.day = 'Dag måste vara mellan 1 och 2 siffror.';
      }
    }
    // zipCode errors
    if (zipCode !== '') {
      if (validNumberRegex.test(zipCode) === false) {
        newErrors.zipCode = 'Endast siffror tillåtet.';
      }
    }
    // city errors
    if (city !== '') {
      if (validTextRegex.test(city) === false) {
        newErrors.city = 'Endast bokstäver tillåtet.';
      }
    }

    return newErrors;
  };

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Skapa ny användare</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <p>Skapa en ny användare för arrangörskontot</p>
          <Form.Group className='mt-2'>
            <Form.Label>E-post</Form.Label>
            <Form.Control
              type='email'
              name='email'
              defaultValue={form?.email}
              placeholder='Ange e-post'
              onChange={(e) => setField('email', e.target.value)}
              isInvalid={!!errors.email}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Lösenord</Form.Label>
            <Form.Control
              type='password'
              name='password'
              placeholder='Ange lösenord'
              defaultValue={form?.password}
              onChange={(e) => setField('password', e.target.value)}
              isInvalid={!!errors.password}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Förnamn</Form.Label>
            <Form.Control
              type='text'
              name='firstName'
              defaultValue={form?.firstName}
              placeholder='Ange förnamn'
              onChange={(e) => setField('firstName', e.target.value)}
              isInvalid={!!errors.firstName}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.firstName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Efternamn</Form.Label>
            <Form.Control
              type='text'
              name='lastName'
              defaultValue={form?.lastName}
              placeholder='Ange efternamn'
              onChange={(e) => setField('lastName', e.target.value)}
              isInvalid={!!errors.lastName}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.lastName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Telefonnummer (frivilligt)</Form.Label>
            <Form.Control
              type='text'
              name='phoneNumber'
              defaultValue={form?.phoneNumber}
              placeholder='Ange telefonnummer'
              onChange={(e) => setField('phoneNumber', e.target.value)}
              isInvalid={!!errors.phoneNumber}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.phoneNumber}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Label className='mt-2'>Födelsedatum (frivilligt)</Form.Label>
          <div className='d-flex justify-content-between gap-2'>
            <Form.Group>
              <Form.Control
                type='number'
                name='year'
                placeholder='Ange år'
                defaultValue={form?.year}
                onChange={(e) => setField('year', e.target.value)}
                isInvalid={!!errors.year}
              />
              <Form.Control.Feedback type='invalid'>
                {errors.year}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
              <Form.Control
                type='number'
                name='month'
                placeholder='Ange månad'
                defaultValue={form?.month}
                onChange={(e) => setField('month', e.target.value)}
                isInvalid={!!errors.month}
              />
              <Form.Control.Feedback type='invalid'>
                {errors.month}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
              <Form.Control
                type='number'
                name='day'
                placeholder='Ange dag'
                defaultValue={form?.day}
                onChange={(e) => setField('day', e.target.value)}
                isInvalid={!!errors.day}
              />
              <Form.Control.Feedback type='invalid'>
                {errors.day}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
          <Form.Group className='mt-2'>
            <Form.Label>Gatuadress (frivilligt)</Form.Label>
            <Form.Control
              type='text'
              name='street'
              placeholder='Ange gatuadress'
              defaultValue={form?.street}
              onChange={(e) => setField('street', e.target.value)}
              isInvalid={!!errors.street}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.street}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Postnummer (frivilligt)</Form.Label>
            <Form.Control
              type='text'
              name='zipCode'
              placeholder='Ange postnummer'
              defaultValue={form?.zipCode}
              onChange={(e) => setField('zipCode', e.target.value)}
              isInvalid={!!errors.zipCode}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.zipCode}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Postort (frivilligt)</Form.Label>
            <Form.Control
              type='text'
              name='city'
              placeholder='Ange postort'
              defaultValue={form?.city}
              onChange={(e) => setField('city', e.target.value)}
              isInvalid={!!errors.city}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.city}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId='nationality' className='mt-2'>
            <Form.Label>Nationalitet (frivilligt)</Form.Label>
            <Form.Select
              name='nationality'
              defaultValue={form?.nationality}
              onChange={(e) => setField('nationality', e.target.value)}
              isInvalid={!!errors.nationality}
            >
              <option value='none' hidden>
                Välj ett land
              </option>
              <option value='Sweden'>Sverige</option>
              <option value='Denmark'>Danmark</option>
              <option value='Norway'>Norge</option>
              <option value='Finland'>Finland</option>
            </Form.Select>
            <Form.Control.Feedback type='invalid'>
              {errors.nationality}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button onClick={handleSubmit} className='mt-2'>
          {confirmBtnText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddOrganizerUserModal;
